import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternalCampaign } from '../../types/external-campaign.interface';
import { SalesforceApiService } from '../salesforce-api.service';
import { SalesforceDataService } from '../salesforce-data.service';
import { SalesforceMappingDialogService } from './salesforce-mapping-dialog.service';
import { ExternalMetricProviderApiService } from '../../types/external-metric-provider-api.service';
import { MetricsProviderDataService } from '../../services/metrics-provider-data.service';
import { MetricMappingDialogData } from '../../components/metric-mapping-dialog/dialog-data.type';
import { BudgetDataService } from '../../../dashboard/budget-data/budget-data.service';

@Component({
  selector: 'salesforce-mapping-dialog',
  templateUrl: './salesforce-mapping-dialog.component.html',
  providers: [
    SalesforceMappingDialogService,
    { provide: ExternalMetricProviderApiService, useClass: SalesforceApiService },
    { provide: MetricsProviderDataService, useClass: SalesforceDataService },
  ]
})
export class SalesforceMappingDialogComponent implements OnInit {
  placeholderText = '';

  private noMatchingCampaignsPlaceholder = `No Salesforce campaigns match this Planful metric.
    This happens when there are no Salesforce campaigns with an end date after this Planful metric start date.`;
  private noMappingsSetPlaceholder = `No Salesforce campaigns match this Planful metric.
    Please ask your Planful admin to map Salesforce metrics to this Planful metric.`;
  salesforceCampaignsList: ExternalCampaign[];

  constructor(
    public dialogRef: MatDialogRef<SalesforceMappingDialogComponent>,
    private metricMappingDialogService: SalesforceMappingDialogService,
    private budgetDataService: BudgetDataService,
    @Inject(MAT_DIALOG_DATA) public data: MetricMappingDialogData) {}

  ngOnInit() {
    this.placeholderText = 'Loading data';
    this.metricMappingDialogService.loadExternalCampaigns(
      {
        companyId: this.data.companyId,
        campaignMetrics: this.data.campaignMetrics,
        campaignId: this.data.campaignId,
        integrationId: this.data.integrationId,
        dateFrom: this.data.dateFrom,
        budget: this.data.budget,
        allCampaigns: this.budgetDataService.lightCampaignsSnapshot || this.budgetDataService.campaignsSnapshot || []
      },
      this.onCampaignsLoaded.bind(this),
      this.onCampaignsLoadFailed.bind(this)
    );
  }

  onSave(campaigns: ExternalCampaign[]) {
    this.metricMappingDialogService.updateCampaignsMapping(campaigns, this.data);
    this.metricMappingDialogService.saveCampaignMapping(
      this.data.companyId,
      this.data.budget.id,
      this.data.campaignId,
      this.data.integrationId,
      this.data.onSavedCb);
    this.dialogRef.close();
  }

  private onCampaignsLoaded(campaigns: ExternalCampaign[], metricTypeMappings: string[]) {
    this.salesforceCampaignsList = campaigns;
    if (!campaigns || !campaigns.length) {
      this.placeholderText = metricTypeMappings && metricTypeMappings.length ?
        this.noMatchingCampaignsPlaceholder :
        this.noMappingsSetPlaceholder;
    }
  }

  private onCampaignsLoadFailed() {
    this.placeholderText = this.noMappingsSetPlaceholder;
  }
}
